/**
 * Created by afuhr on 31.05.2017.
 */

function strEnum<T extends string>(o: Array<T>): {[K in T]: K} {
  return o.reduce((res, key) => {
    res[key] = key;
    return res;
  }, Object.create(null));
}

export const PrintedSheetCategory = {
  Spritzenetiketten: 'cj2r9ixbe00023kt9l0e39el8',
  Allgemein: 'cj2r9ixbe00013kt9ktm7ivp0'
};



// WEBPACK FOOTER //
// ./src/app/medicine-stickers/model/printed-sheets.enum.ts